import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Radio, ChevronRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const NewsTicker = () => {
  const [headlines, setHeadlines] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    fetch(`${API}/api/hub/headlines?limit=6`)
      .then((r) => r.json())
      .then((d) => setHeadlines(d.headlines || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (headlines.length < 2) return;
    const timer = setInterval(() => setIndex((i) => (i + 1) % headlines.length), 5000);
    return () => clearInterval(timer);
  }, [headlines.length]);

  if (headlines.length === 0) return null;
  const current = headlines[index];

  return (
    <div className="max-w-5xl mx-auto px-6 -mb-16 relative z-20" data-testid="news-ticker">
      <div className="bg-white border border-stone-200 shadow-lg rounded-2xl px-5 py-4 flex items-center gap-4">
        <span className="flex items-center gap-2 text-emerald-700 text-xs font-semibold tracking-wider uppercase whitespace-nowrap">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-60"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-600"></span>
          </span>
          <Radio className="h-4 w-4 hidden sm:block" />
          Latest Property Update
        </span>
        <div className="flex-1 min-w-0 overflow-hidden h-6">
          <AnimatePresence mode="wait">
            <motion.div
              key={current.id}
              initial={{ y: 16, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -16, opacity: 0 }}
              transition={{ duration: 0.35, ease: 'easeOut' }}
            >
              <Link to={`/property-hub/${current.slug}`} data-testid="ticker-headline"
                className="text-stone-700 hover:text-emerald-700 text-sm font-medium truncate block transition-colors">
                {current.title}
              </Link>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="flex gap-1">
          {headlines.map((_, i) => (
            <button key={i} onClick={() => setIndex(i)} aria-label={`Headline ${i + 1}`}
              data-testid={`ticker-dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-5 bg-emerald-600' : 'w-1.5 bg-stone-300'}`} />
          ))}
        </div>
        <ChevronRight className="h-4 w-4 text-stone-400 hidden sm:block" />
      </div>
    </div>
  );
};

export default NewsTicker;
